import axios from 'axios'

const onSuccess = (response) => {
  return Promise.resolve(response)
}

const onError = (e) => {
  return Promise.reject(e.response)
}

export default {
  baseUrl: () => '/admins/',

  get: function (url, requestVars) {
    return axios.get(this.baseUrl() + url + '.json', {
      params: requestVars
    })
      .then(onSuccess)
      .catch(onError)
  },

  post: function (url, params) {
    return axios.post(this.baseUrl() + url, params, { headers: {
        'Content-Type': 'application/json'
      } })
      .then(onSuccess)
      .catch(onError)
  },

  patch: function (url, params) {
    return axios.patch(this.baseUrl() + url, params, { headers: {
        'Content-Type': 'application/json',
      } })
      .then(onSuccess)
      .catch(onError)
  },

  delete: function (url, params) {
    return axios.delete(this.baseUrl() + url,
      {
        data: params
      })
      .then(onSuccess)
      .catch(onError)
  }
}
